import { useSubmenu } from '../hooks/useSubmenu';

const SubMenuContainer = ({ children }: any) => {
	const { blockClass, width } = useSubmenu();

	return (
		<div
			className={`vtex-menu-2-x-submenuContainer submenuContainer ${blockClass ? `vtex-menu-2-x-submenuContainer--${blockClass} submenuContainer--${blockClass}` : ''} ${width === '100%' ? '' : 'relative'}`}
		>
			{children}
		</div>
	);
};

export default SubMenuContainer;
